<script setup>
import { onMounted } from 'vue';

onMounted(() => {

});
</script>
<template>
  <router-view />
</template>